import { ReactNode } from 'react';
import { OverflowTooltip } from '@elementary/common-ui/components';
import {
  OwnersChipList,
  TagsChipList,
} from '@elementary/common-ui/components/ChipList';
import { AddTestForm } from 'shared/types';
import { getConditionalSeverityString } from 'testManagement/utils/utils';
import SeverityRenderer from '../SeverityRenderer';

export const REVIEW_FIELDS: Array<keyof AddTestForm> = [
  'description',
  'owners',
  'tags',
  'severity',
];

export const changeRenderers: {
  [K in keyof Partial<AddTestForm>]: (val: AddTestForm[K]) => ReactNode;
} = {
  description: (val) => <OverflowTooltip maxLines={2}>{val}</OverflowTooltip>,
  owners: (val) => <OwnersChipList value={val} readOnly buttonText="test" />,
  tags: (val) => <TagsChipList value={val} readOnly buttonText="test" />,
  severity: (val) => {
    const { warnIf, errorIf } = getConditionalSeverityString(val);
    return (
      <SeverityRenderer
        severity={val.type || 'error'}
        warnIf={warnIf}
        errorIf={errorIf}
        showTitle={false}
      />
    );
  },
};
